import React from 'react'
import SimpleImageSlider from "react-simple-image-slider";
import './ImageSlider.css'

const ImageSlider = props => {
    const { images, addImageFunction, deleteImageFunction} = props;
    const [sliderImages, setSliderImages] = React.useState(images);
    const [currentImageIndex, setCurrentImageIndex] = React.useState(0);
    const deleteImage = async() => {
        const tmp = sliderImages.slice();
        await deleteImageFunction(sliderImages[currentImageIndex]);
        tmp.splice(currentImageIndex, 1);
        setSliderImages([]);
        setSliderImages(tmp);
    }

    const addImages = async (event) => {
        const file = event.target.files ? event.target.files[0] : null;
        if (file) {
            const tmp = sliderImages.slice();
            const newImage = await addImageFunction(file);
            tmp.unshift(newImage);
            setSliderImages([]);
            setSliderImages(tmp);
        }
    }
    const onNavClickAction = (toRight) => {
        if(toRight){
            setCurrentImageIndex(currentImageIndex+1);
        } else {
            setCurrentImageIndex(currentImageIndex-1);
        }
    }


    return (
        <div className="slider-container">
            {sliderImages&&sliderImages.length>0 &&
                <>
                    <SimpleImageSlider
                        showBullets={true}
                        showNavs={true}
                        navStyle={2}
                        navSize={30}
                        navMargin={10}
                        slideDuration={1}
                        onClickNav={onNavClickAction}
                        onClickBullets={setCurrentImageIndex}
                        images={sliderImages}
                    />
                    <i className="fa fa-trash delete-button" onClick={deleteImage}></i>
                    <label className="add-button">
                        <i className="fa fa-camera " onClick={addImages}></i>
                        <input style={{ display: 'none' }} id="event-image" type="file" accept="image/*" onChange={addImages}/>
                    </label>
                </>
            }
        </div>
    )
}
export default ImageSlider
